export const thumbMediaWrapClassName = "relative size-full min-h-0";

export const thumbSkeletonClassName =
  "absolute inset-0 z-0 rounded-[inherit] bg-[linear-gradient(92deg,rgba(255,255,255,0.04)_0%,rgba(255,255,255,0.1)_42%,rgba(255,255,255,0.04)_84%)] [background-size:200%_100%] animate-[editorSceneCardThumbSkeletonPulse_1.25s_ease-in-out_infinite] motion-reduce:animate-none motion-reduce:bg-white/[0.06]";

export const thumbMediaClassName =
  "relative z-[1] block size-full object-cover opacity-0 transition-opacity duration-[220ms] [transition-timing-function:ease]";

export const thumbMediaReadyClassName = "opacity-100";

export const thumbFallbackClassName =
  "size-full bg-[radial-gradient(circle_at_20%_15%,rgba(138,63,252,0.22),transparent_55%),linear-gradient(180deg,rgba(255,255,255,0.08),rgba(255,255,255,0.02))]";
